<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Список клиентов и&nbsp;их данные</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="spisok-klientov"
            class="typography__headline2"
          >
            Список клиентов
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Клиенты&raquo;.</p>

            <p>Сверху справа можно добавить нового клиента, нажав соответствующую кнопку.</p>

            <p>
              В&nbsp;списке есть важная информация о&nbsp;клиенте&nbsp;&mdash; номер телефона и&nbsp;когда последний раз
              заходил на&nbsp;сайт, а&nbsp;также кнопка для перехода к&nbsp;чату с&nbsp;ним и&nbsp;возможность перейти
              к&nbsp;редактированию или удалению.
            </p>

            <p>
              Если клиент был добавлен через CRM и&nbsp;не&nbsp;заходил на&nbsp;сайт&nbsp;&mdash; его активность
              и&nbsp;чат будут пустые.
            </p>

            <p>По&nbsp;нажатию на&nbsp;имя клиента перейдем к&nbsp;его странице.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/spisok-klientov-i-ikh-dannye-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>Над списком есть сортировка, фильтры и&nbsp;поисковая строка для быстрого поиска нужного клиента.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/spisok-klientov-i-ikh-dannye-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="stranica-klientov"
            class="typography__headline2"
          >
            Страница клиента
          </FaqArticlesBlockHeading>

          <p>
            На&nbsp;открывшейся странице клиента можно увидеть всю доступную информацию, подключенные социальные сети,
            адреса доставки и&nbsp;перейти к&nbsp;редактированию или удалить его.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/spisok-klientov-i-ikh-dannye-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            В&nbsp;блоках ниже можно посмотреть все заказы, записи и&nbsp;заявки, оформленные этим клиентом,
            и&nbsp;перейти к&nbsp;нужной странице по&nbsp;нажатию на&nbsp;неё.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/spisok-klientov-i-ikh-dannye-4.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Как добавлением клиента и просмотров его страницы разобрались. Самое время перейти к изучению
            <BaseLink
              class="ui-link-secondary"
              to="/faq/articles/chat-s-klientom"
            >
              чата с клиентом</BaseLink
            >.
          </p>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Клиенты",
    url: "/faq/categories/klienty",
  },
  {
    name: "Список клиентов и&nbsp;их данные",
  },
];

const menu = [
  {
    name: "Список&nbsp;клиентов",
    url: "spisok-klientov",
  },
  {
    name: "Страница&nbsp;клиента",
    url: "stranica-klientov",
  },
];

const relatedArticles = [
  {
    name: "Добавление и&nbsp;редактирование клиента",
    slug: "dobavleniye-i-redaktirovaniye-klienta",
  },
  {
    name: "Чат с&nbsp;клиентом",
    slug: "chat-s-klientom",
  },
];

useSeoMeta({
  title: "Список клиентов и их данные",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
